import { DIRECTIONS } from '@eti/providers';
import { css, cx } from '@eti/styles';
import { jsx as _jsx } from "react/jsx-runtime";
const {
  LTR,
  RTL
} = DIRECTIONS;
const svgStyles = direction => css`
  fill: #fff;
  margin-right: 8px;
  position: relative;
  top: 1px;
  transform: ${direction === RTL ? 'rotateY(180deg)' : 'rotateY(0deg)'};
  transition: transform 0.2s ease-in-out;
  width: 1rem;
`;
const DirectionArrows = _ref => {
  let {
    className,
    direction
  } = _ref;
  return /*#__PURE__*/_jsx("svg", {
    className: cx(svgStyles(direction), className),
    viewBox: "0 0 64 64",
    children: /*#__PURE__*/_jsx("path", {
      d: "M64 40v6.857A1.174 1.174 0 0 1 62.857 48H13.714v6.857A1.15 1.15 0 0 1 12.571 56a1.321 1.321 0 0 1-.857-.357L.322 44.215A1.109 1.109 0 0 1 0 43.429a1.123 1.123 0 0 1 .322-.821l11.429-11.429a1.193 1.193 0 0 1 .82-.322A1.151 1.151 0 0 1 13.714 32v6.857h49.143A1.151 1.151 0 0 1 64 40zm0-19.429a1.185 1.185 0 0 1-.322.821L52.249 32.821a1.193 1.193 0 0 1-.82.322A1.174 1.174 0 0 1 50.286 32v-6.857H1.143A1.174 1.174 0 0 1 0 24v-6.857A1.174 1.174 0 0 1 1.143 16h49.143V9.143A1.129 1.129 0 0 1 51.429 8a1.321 1.321 0 0 1 .857.357l11.392 11.392a1.185 1.185 0 0 1 .322.82z"
    })
  });
};
export default DirectionArrows;
//# sourceMappingURL=DirectionArrows.js.map